import { default as _91contentSlug_931OZJNDe6mmMeta } from "/build/pages/[slug]/[contentSlug].vue?macro=true";
import { default as indexoMVairUXgZMeta } from "/build/pages/[slug]/index.vue?macro=true";
import { default as activate_45user3opojRi5iLMeta } from "/build/pages/activate-user.vue?macro=true";
import { default as cartZokP31okItMeta } from "/build/pages/cart.vue?macro=true";
import { default as checkout_45success_45pagegIY2pObyx1Meta } from "/build/pages/checkout-success-page.vue?macro=true";
import { default as deliveryV5HnvlHZ66Meta } from "/build/pages/delivery.vue?macro=true";
import { default as gloemt_45loesenordgSgmbMHbG7Meta } from "/build/pages/gloemt-loesenord.vue?macro=true";
import { default as hitta_45butikppxOaIawhTMeta } from "/build/pages/hitta-butik.vue?macro=true";
import { default as index2yY1hMMS9YMeta } from "/build/pages/index.vue?macro=true";
import { default as _91slug_93pg5n1fiIqnMeta } from "/build/pages/kampanjer/[slug].vue?macro=true";
import { default as indexAGsKwVaEtdMeta } from "/build/pages/kampanjer/index.vue?macro=true";
import { default as _91_46_46_46slug_93X8e4R64txwMeta } from "/build/pages/kategorier/[...slug].vue?macro=true";
import { default as _91slug_9372H2lPHQu2Meta } from "/build/pages/produkt/[slug].vue?macro=true";
import { default as searchjBoxpGrlzzMeta } from "/build/pages/search.vue?macro=true";
import { default as _91slug_93vNd1w2U3NoMeta } from "/build/pages/sortiment/[slug].vue?macro=true";
import { default as indexzHLGmettBaMeta } from "/build/pages/sortiment/index.vue?macro=true";
import { default as summarymqHLKn7q03Meta } from "/build/pages/summary.vue?macro=true";
export default [
  {
    name: _91contentSlug_931OZJNDe6mmMeta?.name ?? "slug-contentSlug",
    path: _91contentSlug_931OZJNDe6mmMeta?.path ?? "/:slug()/:contentSlug()",
    meta: _91contentSlug_931OZJNDe6mmMeta || {},
    alias: _91contentSlug_931OZJNDe6mmMeta?.alias || [],
    redirect: _91contentSlug_931OZJNDe6mmMeta?.redirect || undefined,
    component: () => import("/build/pages/[slug]/[contentSlug].vue").then(m => m.default || m)
  },
  {
    name: indexoMVairUXgZMeta?.name ?? "slug",
    path: indexoMVairUXgZMeta?.path ?? "/:slug()",
    meta: indexoMVairUXgZMeta || {},
    alias: indexoMVairUXgZMeta?.alias || [],
    redirect: indexoMVairUXgZMeta?.redirect || undefined,
    component: () => import("/build/pages/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: activate_45user3opojRi5iLMeta?.name ?? "activate-user",
    path: activate_45user3opojRi5iLMeta?.path ?? "/activate-user",
    meta: activate_45user3opojRi5iLMeta || {},
    alias: activate_45user3opojRi5iLMeta?.alias || [],
    redirect: activate_45user3opojRi5iLMeta?.redirect || undefined,
    component: () => import("/build/pages/activate-user.vue").then(m => m.default || m)
  },
  {
    name: cartZokP31okItMeta?.name ?? "cart",
    path: cartZokP31okItMeta?.path ?? "/cart",
    meta: cartZokP31okItMeta || {},
    alias: cartZokP31okItMeta?.alias || [],
    redirect: cartZokP31okItMeta?.redirect || undefined,
    component: () => import("/build/pages/cart.vue").then(m => m.default || m)
  },
  {
    name: checkout_45success_45pagegIY2pObyx1Meta?.name ?? "checkout-success-page",
    path: checkout_45success_45pagegIY2pObyx1Meta?.path ?? "/checkout-success-page",
    meta: checkout_45success_45pagegIY2pObyx1Meta || {},
    alias: checkout_45success_45pagegIY2pObyx1Meta?.alias || [],
    redirect: checkout_45success_45pagegIY2pObyx1Meta?.redirect || undefined,
    component: () => import("/build/pages/checkout-success-page.vue").then(m => m.default || m)
  },
  {
    name: deliveryV5HnvlHZ66Meta?.name ?? "delivery",
    path: deliveryV5HnvlHZ66Meta?.path ?? "/delivery",
    meta: deliveryV5HnvlHZ66Meta || {},
    alias: deliveryV5HnvlHZ66Meta?.alias || [],
    redirect: deliveryV5HnvlHZ66Meta?.redirect || undefined,
    component: () => import("/build/pages/delivery.vue").then(m => m.default || m)
  },
  {
    name: gloemt_45loesenordgSgmbMHbG7Meta?.name ?? "gloemt-loesenord",
    path: gloemt_45loesenordgSgmbMHbG7Meta?.path ?? "/gloemt-loesenord",
    meta: gloemt_45loesenordgSgmbMHbG7Meta || {},
    alias: gloemt_45loesenordgSgmbMHbG7Meta?.alias || [],
    redirect: gloemt_45loesenordgSgmbMHbG7Meta?.redirect || undefined,
    component: () => import("/build/pages/gloemt-loesenord.vue").then(m => m.default || m)
  },
  {
    name: hitta_45butikppxOaIawhTMeta?.name ?? "hitta-butik",
    path: hitta_45butikppxOaIawhTMeta?.path ?? "/hitta-butik",
    meta: hitta_45butikppxOaIawhTMeta || {},
    alias: hitta_45butikppxOaIawhTMeta?.alias || [],
    redirect: hitta_45butikppxOaIawhTMeta?.redirect || undefined,
    component: () => import("/build/pages/hitta-butik.vue").then(m => m.default || m)
  },
  {
    name: index2yY1hMMS9YMeta?.name ?? "index",
    path: index2yY1hMMS9YMeta?.path ?? "/",
    meta: index2yY1hMMS9YMeta || {},
    alias: index2yY1hMMS9YMeta?.alias || [],
    redirect: index2yY1hMMS9YMeta?.redirect || undefined,
    component: () => import("/build/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93pg5n1fiIqnMeta?.name ?? "kampanjer-slug",
    path: _91slug_93pg5n1fiIqnMeta?.path ?? "/kampanjer/:slug()",
    meta: _91slug_93pg5n1fiIqnMeta || {},
    alias: _91slug_93pg5n1fiIqnMeta?.alias || [],
    redirect: _91slug_93pg5n1fiIqnMeta?.redirect || undefined,
    component: () => import("/build/pages/kampanjer/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexAGsKwVaEtdMeta?.name ?? "kampanjer",
    path: indexAGsKwVaEtdMeta?.path ?? "/kampanjer",
    meta: indexAGsKwVaEtdMeta || {},
    alias: indexAGsKwVaEtdMeta?.alias || [],
    redirect: indexAGsKwVaEtdMeta?.redirect || undefined,
    component: () => import("/build/pages/kampanjer/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93X8e4R64txwMeta?.name ?? "kategorier-slug",
    path: _91_46_46_46slug_93X8e4R64txwMeta?.path ?? "/kategorier/:slug(.*)*",
    meta: _91_46_46_46slug_93X8e4R64txwMeta || {},
    alias: _91_46_46_46slug_93X8e4R64txwMeta?.alias || [],
    redirect: _91_46_46_46slug_93X8e4R64txwMeta?.redirect || undefined,
    component: () => import("/build/pages/kategorier/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_9372H2lPHQu2Meta?.name ?? "produkt-slug",
    path: _91slug_9372H2lPHQu2Meta?.path ?? "/produkt/:slug()",
    meta: _91slug_9372H2lPHQu2Meta || {},
    alias: _91slug_9372H2lPHQu2Meta?.alias || [],
    redirect: _91slug_9372H2lPHQu2Meta?.redirect || undefined,
    component: () => import("/build/pages/produkt/[slug].vue").then(m => m.default || m)
  },
  {
    name: searchjBoxpGrlzzMeta?.name ?? "search",
    path: searchjBoxpGrlzzMeta?.path ?? "/search",
    meta: searchjBoxpGrlzzMeta || {},
    alias: searchjBoxpGrlzzMeta?.alias || [],
    redirect: searchjBoxpGrlzzMeta?.redirect || undefined,
    component: () => import("/build/pages/search.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93vNd1w2U3NoMeta?.name ?? "sortiment-slug",
    path: _91slug_93vNd1w2U3NoMeta?.path ?? "/sortiment/:slug()",
    meta: _91slug_93vNd1w2U3NoMeta || {},
    alias: _91slug_93vNd1w2U3NoMeta?.alias || [],
    redirect: _91slug_93vNd1w2U3NoMeta?.redirect || undefined,
    component: () => import("/build/pages/sortiment/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexzHLGmettBaMeta?.name ?? "sortiment",
    path: indexzHLGmettBaMeta?.path ?? "/sortiment",
    meta: indexzHLGmettBaMeta || {},
    alias: indexzHLGmettBaMeta?.alias || [],
    redirect: indexzHLGmettBaMeta?.redirect || undefined,
    component: () => import("/build/pages/sortiment/index.vue").then(m => m.default || m)
  },
  {
    name: summarymqHLKn7q03Meta?.name ?? "summary",
    path: summarymqHLKn7q03Meta?.path ?? "/summary",
    meta: summarymqHLKn7q03Meta || {},
    alias: summarymqHLKn7q03Meta?.alias || [],
    redirect: summarymqHLKn7q03Meta?.redirect || undefined,
    component: () => import("/build/pages/summary.vue").then(m => m.default || m)
  }
]